module.exports = __webpack_public_path__ + "img/northstar-6.508ed522.jpg";